import { render, staticRenderFns } from "./BlogArticleIndex.vue?vue&type=template&id=dedf8286&scoped=true"
import script from "./BlogArticleIndex.vue?vue&type=script&lang=js"
export * from "./BlogArticleIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dedf8286",
  null
  
)

export default component.exports